import React, { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export function ModalProvider({ children }) {
  const [currentModal, setCurrentModal] = useState({ name: null, props: {} });
  //const [currentModal, setCurrentModal] = useState(null);

  const openModal = (name, props = {}) => {
     setCurrentModal({ name, props });
   };
  //const openModal = (modalName)=>setCurrentModal(modalName);

  const closeModal = () => {
     setCurrentModal({ name: null, props: {} });
  };
  //const closeModal = () => setCurrentModal(null);
  return (
    <ModalContext.Provider value={{ currentModal, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used inside a ModalProvider");
  }
  //console.log("context in useModal:", context);
  return context;
}